// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user_sales_case {
    display: flex;
    flex-direction: column;
    background-color: var(--bg-card);
    padding: 20px;
    border-radius: 15px;
    gap: 15px;
    border: 1px solid var(--border);
    box-shadow: var(--shadow-sm);
}

.user_doc_title {
    margin: 0 0 20px 0;
    font-size: 22px;
    font-weight: bold;
}

.user_sales_p {
    margin: 5px 0;
}

.user_sales_associated_users {
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    color: var(--text-secondary);
    align-items: center;
}

.user_sales_box {
    display: flex;
    flex-direction: column;
    gap: 7px;
}

.user_sales_delete_button {
    color: var(--danger);
    font-weight: 900;
    font-size: 16px;
}`, "",{"version":3,"sources":["webpack://./src/pages/users/userById/UserSections/UserSales/userSales.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,+BAA+B;IAC/B,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;AACnB","sourcesContent":[".user_sales_case {\n    display: flex;\n    flex-direction: column;\n    background-color: var(--bg-card);\n    padding: 20px;\n    border-radius: 15px;\n    gap: 15px;\n    border: 1px solid var(--border);\n    box-shadow: var(--shadow-sm);\n}\n\n.user_doc_title {\n    margin: 0 0 20px 0;\n    font-size: 22px;\n    font-weight: bold;\n}\n\n.user_sales_p {\n    margin: 5px 0;\n}\n\n.user_sales_associated_users {\n    margin: 0;\n    font-size: 14px;\n    font-weight: 600;\n    color: var(--text-secondary);\n    align-items: center;\n}\n\n.user_sales_box {\n    display: flex;\n    flex-direction: column;\n    gap: 7px;\n}\n\n.user_sales_delete_button {\n    color: var(--danger);\n    font-weight: 900;\n    font-size: 16px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
